export const uk = {
    languages: {
        cs: 'Чеська',
        de: 'Німецька',
        en: 'Англійська',
        es: 'Іспанська',
        fr: 'Французька',
        hr: 'Хорватська',
        hu: 'Угорська',
        it: 'Італійська',
        nl: 'Голландська',
        pl: 'Польська',
        ru: 'Російська',
        sk: 'Словацька',
        tr: 'Турецька',
        uk: 'Українська',
        undefined: 'Без субтитрів',
    },
    player: {
        content: {
            notFound: { title: 'Помилка під час завантаження медіа елемента 😞' },
        },
        controls: {
            backwards: { title: '10с назад' },
            buffering: { title: 'Завантаження...' },
            captions: { title: 'Субтитри' },
            forwards: { title: '10с вперед' },
            fullscreen: { title: 'Повний екран' },
            pause: { title: 'Пауза' },
            play: { title: 'Відтворити' },
            playlist: { title: 'Плейлист' },
            volume: { title: 'Гучність' },
        },
    },
};
